export default (props, context) => {
	const { formData = [] } = context;
	const {
		desktopTrigger = "none",
		mobileTrigger = "none",
		formDetails = [],
	} = props;

	return {
		...props,
		desktopTrigger,
		mobileTrigger,
		hubspotFormContent: formDetails[0] || null,
		context,
		formData,
	};
};
